"use strict";

module.exports = [{
  name: "bnb",
  gallery: [{
    url: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_1_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_1_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_2_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_2_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_3_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_3_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_4_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_4_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_5_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_5_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_6_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_6_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_7_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/bnb/bnb_7_1800.jpg"
  }]
}, {
  name: "cafe",
  gallery: [{
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_1_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_1_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_2_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_2_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_3_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_3_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_4_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_4_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_5_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_5_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_6_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_6_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_7_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_7_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_8_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_8_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_9_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_9_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_10_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_10_1800.jpg"
  }, {
    url: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_11_600.jpg",
    name: "https://canner-qa.s3.amazonaws.com/gallery/coffee/coffee_11_1800.jpg"
  }]
}];